export default __webpack_public_path__ + "static/media/sidebar-background.3f4c5a47.jpg";